import { render, staticRenderFns } from "./SkinDysfunctions.vue?vue&type=template&id=705b9afa"
import script from "./SkinDysfunctions.vue?vue&type=script&lang=js"
export * from "./SkinDysfunctions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports